const defaultState = {
  start: Date.now(),
  end: Date.now(),
  selectedCanvasser: 0,
  selectedOffice: 0,
  selectedScript: null,
  assignedSites: [],
  assignedTurfs: [],
};

const dashboardParams = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_DASHBOARD_PARAM':
      return { ...state, ...action.data };

    default:
      return state;
  }
};

export default dashboardParams;
